import React, { memo } from 'react';
import { useAppSelector } from 'hooks/redux';
import Lobby from 'modules/Lobby';
import Tile, { Variant } from 'components/Tile';
import type { Normalized, Slot, SlotTile as LobbySlotTile } from 'lib/LobbyEntities';
import withLazyStyle from 'components/LazyStyle';
import useSlotTileAnalytics from '../../hooks/useSlotTileAnalytics';
import style from './slotTile.css?lazy';

interface SlotTileProps {
  entity: LobbySlotTile;
  position: number;
}

const slotTileSizes = {
  [Variant.Square]: {
    width: 164,
    height: 164
  },
  [Variant.VerticalRectangle]: {
    width: 164,
    height: 246
  }
};

const SlotTile = ({ entity: slotTile, position }: SlotTileProps) => {
  const { shape, game } = slotTile;
  const tile = useAppSelector((state) =>
    Lobby.selectors.getEntityByKey(state, game.__access)
  ) as Normalized<Slot> | null;
  const { trackGameLaunched } = useSlotTileAnalytics({
    tile,
    source: 'Dynamic lobby',
    position,
    shape
  });

  if (!tile) {
    return null;
  }

  const { refName, title, imageURL, blur, jackpotAmount } = tile;

  return (
    <div className="dynamicLobby__slotTile" onClick={trackGameLaunched}>
      <Tile
        link={`/secure/games/${refName}`}
        imageUrl={imageURL}
        imageAlt={title}
        isBlurred={blur}
        jackpotAmount={jackpotAmount}
        resizeWidth={slotTileSizes[shape]?.width}
        resizeHeight={slotTileSizes[shape]?.height}
        variant={shape}
        imageLoadingType="lazy"
        isolateTouch
      />
    </div>
  );
};

export default memo(withLazyStyle(style)(SlotTile));
